import { environment } from '../../environments/environment';

import { Trigger } from 'src/app/models/trigger';
import { Video } from 'src/app/models/video';
import { ContentList } from 'src/app/models/content-list';
import { Content } from 'src/app/models/content';
import { User } from 'src/app/models/user';
import { UserVideo } from 'src/app/models/user-video';
import { Start } from 'src/app/models/start';

import { QuestionSelect } from 'src/app/models/question-select';
import { QuestionText } from 'src/app/models/question-text';
import { QuestionRating } from 'src/app/models/question-rating';
import { CtaSimple } from 'src/app/models/cta-simple';
import { MessageSimple } from 'src/app/models/message-simple';
import { FormOverlay } from 'src/app/models/form-overlay';
import { Form } from 'src/app/models/form';

export class Playlist{

  // Playlistの場合
  playlistHash:string;
  playlistHashPublic:string;
  title:string;

  color:string = "#333";
  chapterMode: "hidden" | "overlay" | "fixed" = "hidden"; // fixedは未実装

  // Videoアンケートの場合
  videoHash:string;
  videoHashPublic:string;

  // 共通
  type:  "playlist" | "video";
  enable:boolean;
  registDate:Date;
  updateDate:Date;
  startAt:string;
  start:Start;
  // startTrigger:Trigger;
  contents:Array<any> = [];
  user:User;
  reportSummary:ReportSummary;
    
  constructor(object = null){
    this.start = new Start();
    if(object){
      this.set(object);
    }
  };

  set(object){

    if(object.videoHashPublic){
      this.type = "video";
    }
    else{
      this.type = "playlist";
    }

    // Playlistの場合
    if(object.playlistHashPublic){
      this.playlistHashPublic = object.playlistHashPublic;
    }
    if(object.playlistHash){
      this.playlistHash = object.playlistHash;
    }
    if(object.title){
      this.title = object.title;
    }
    if(object.color){
      this.color = object.color;
    }
    if(object.chapterMode){
      this.chapterMode = object.chapterMode;
    }

    if(object.registDate){
      this.registDate = new Date(object.registDate * 1000);
    }
    if(object.updateDate){
      this.updateDate = new Date(object.updateDate * 1000);
    }

    // Videoアンケートの場合
    if(object.videoHashPublic){
      this.videoHashPublic = object.videoHashPublic;
    }

    // 共通項目
    if(object.enable){
      this.enable = object.enable;
    }
    if(object.user){
      this.user = new User(object.user);
    }

    if(object.data){
  
      Object.keys(object.data.contents).forEach((key) => {

        let contentObject = object.data.contents[key];

        let content:any;
        if(contentObject.type == "Video"){
          content = new Video(contentObject);
        }
        if(contentObject.type == 'QuestionSelect'){
          content = new QuestionSelect(contentObject);
        }
        if(contentObject.type == 'QuestionText'){
          content = new QuestionText(contentObject);
        }
        if(contentObject.type == 'QuestionRating'){
          content = new QuestionRating(contentObject);
        }
        if(contentObject.type == 'CtaSimple'){
          content = new CtaSimple(contentObject);
        }
        if(contentObject.type == 'MessageSimple'){
          content = new MessageSimple(contentObject);
        }
        if(contentObject.type == 'FormOverlay'){
          content = new FormOverlay(contentObject);
          if(content.form.isVisitorOnly == Form.IsVisitorOnlyTrue){
            // すでにProspect化している人には表示しない
            if(window.onerollTrack && window.onerollTrack.isProspect){
              return;
            }
          }
        }

        if(! content){
          return;
        }

        this.contents.push(content);

        if(object.data.startAt){
          if(content.hash == object.data.startAt){
            this.setStartAtContent(content);
          }
        }  
      });

      for(let content of this.contents){
        if(! content.trigger){
          continue;
        }

        if(content.trigger.nextType == "MainContent"){
          let nextContent = this.getMainContent(content.trigger.nextMainContentHash);
          content.trigger.nextContent = nextContent;
          nextContent.addParentTrigger(content.trigger);
        }
        else if(content.trigger.nextType == "SubContent"){
          let nextContent = this.getSubContent(content.trigger.nextMainContentHash, content.trigger.nextSubContentListHash, content.trigger.nextSubContentHash);
          content.trigger.nextContent = nextContent;
          nextContent.addParentTrigger(content.trigger);
        }
      }
      
    }

    const reportSummary:ReportSummary = {
      views: 0,
      viewUsers: 0,
      answers: 0,
    };
    this.reportSummary = reportSummary;
    if(object.reportSummary){
      if(object.reportSummary.views){
        reportSummary.views = object.reportSummary.views;
      }
      if(object.reportSummary.viewUsers){
        reportSummary.viewUsers = object.reportSummary.viewUsers;
      }
      if(object.reportSummary.answers){
        reportSummary.answers = object.reportSummary.answers;
      }
    }
  }

  setStartAtContent(content){
    this.startAt = content.hash;
    this.start.trigger = new Trigger();
    this.start.trigger.baseContent = this.start;
    this.start.trigger.nextType = "MainContent";
    content.addParentTrigger(this.start.trigger);

    const mainContent = this.getMainContent(this.startAt);
    if(! mainContent){
      return;
    }

    if(mainContent.type == "Video"){
      this.start.trigger.nextMainContentHash = this.startAt;  
    }
    else{
      this.start.trigger.nextMainContentHash = this.startAt;
    }
  }

  getJsonForSave(){
    let playlistObject = this.getPlaylistObject();
    return JSON.stringify(playlistObject);
  }

  getJsonForPreview(){
    let playlistObject = this.getPlaylistObject(true);
    let previewPlaylistObject = {
      "success": true,
      "isPreviewMode": true,
      // "hashPublic": this.hash,
      "playlist": {
        "version": 1,
        // "color": "#00aaff",
        "data": playlistObject
      }
    };
    return JSON.stringify(previewPlaylistObject);
  }

  // Preview:true -> プレビュー用のplaylist objectを取得
  // Preview:false -> 保存用のplaylist objectを取得
  // ※保存用はUserVideoに紐づくlegacyフォームはdataに保存しない
  getPlaylistObject(isPreview = false){
    if(this.contents.length == 0){
      return {
        startAt: "",
        contents: [],
      };
    }

    let startAt = "";
    let startTrigger = this.start.trigger;
    if(startTrigger){
        startAt = startTrigger.nextMainContentHash;
    }

    let mainContentObjects = {};
    for(let mainContent of this.contents){

      if(! isPreview && mainContent.legacy){
        continue;
      }

      let mainContentObject;

      if(mainContent.type == "Video"){
        mainContentObject = {
          hash: mainContent.hash,
          canvasX: mainContent.canvasX,
          canvasY: mainContent.canvasY,
          hashPublic: mainContent.userVideo.hashPublic,
          type: mainContent.type,
          triggers: [],
          contentLists: [],
        };
  
        if(isPreview){
          mainContentObject["userVideo"] = mainContent.userVideo;
        }

        for(let trigger of mainContent.triggers){
          if(trigger.legacy){
            continue;
          }
          let triggerObject = trigger.getTriggerObject();
          mainContentObject["triggers"].push(triggerObject);
        }
        if(mainContent.trigger){
          if(mainContent.trigger.legacy){
            continue;
          }
          mainContentObject["trigger"] = mainContent.trigger.getTriggerObject();
        }
  
        for(let contentList of mainContent.contentLists){
          if(contentList.legacy){
            continue;
          }
          let contentListStateObject = {
            hash: contentList.hash,
            type: "ContentList",
            startAt: contentList.startAt,
            contents: [],
          };
          for(let subContent of contentList.contents){
            if(subContent.legacy){
              continue;
            }
  
            let subContentObject = {
              hash: subContent.hash,
              type: subContent.type,
              title: subContent.title,
              videoReplay: subContent.videoReplay,
              replay: subContent.replay,
              canvasX: subContent.canvasX,
              canvasY: subContent.canvasY,
            };
            if(subContent.trigger){
              let triggerObject = subContent.trigger.getTriggerObject();
              subContentObject["trigger"] = triggerObject;
            }
  
            if(subContent.type == "CtaSimple"){
              subContentObject["linkUrl"] = subContent.linkUrl;
            }
            if(subContent.type == "MessageSimple"){
              subContentObject["description"] = subContent.description;
            }
            if(subContent.type == "QuestionSelect"){
              subContentObject["options"] = [];
              for(let option of subContent.options){
                let optionObject = {
                  key: option.key,
                  value: option.value,
                };
                if(option.trigger){
                  let triggerObject = option.trigger.getTriggerObject();
                  optionObject["trigger"] = triggerObject;
                }
                subContentObject["options"].push(optionObject);
              }
              
              subContentObject["required"] = subContent.required;
              subContentObject["isMultiSelect"] = subContent.isMultiSelect;
            }
            if(subContent.type == "QuestionText"){
              subContentObject["required"] = subContent.required;
            }
            if(subContent.type == "QuestionRating"){
              subContentObject["required"] = subContent.required;
            }
            if(subContent.type == "FormOverlay"){
              subContentObject["title"] = subContent.title;
              subContentObject["description"] = subContent.description;
              subContentObject["sendBtnTitle"] = subContent.sendBtnTitle;
              subContentObject["sendCompleteType"] = subContent.sendCompleteType;
              subContentObject["sendCompleteTitle"] = subContent.sendCompleteTitle;
              subContentObject["sendCompleteDescription"] = subContent.sendCompleteDescription;
              // subContentObject["overlayWithName"] = subContent.overlayWithName;
              subContentObject["withSkip"] = subContent.withSkip;
              subContentObject["isVisitorOnly"] = subContent.isVisitorOnly;
              subContentObject["showTiming"] = subContent.showTiming;  
            }

            contentListStateObject.contents.push(subContentObject);
          }
          mainContentObject.contentLists.push(contentListStateObject);
        }        
      }
      else{
        mainContentObject = {
          hash: mainContent.hash,
          type: mainContent.type,
          title: mainContent.title,
          videoReplay: mainContent.videoReplay,
          replay: mainContent.replay,
          canvasX: mainContent.canvasX,
          canvasY: mainContent.canvasY,
        };
        if(mainContent.trigger){
          if(mainContent.trigger.legacy){
            continue;
          }

          let triggerObject = mainContent.trigger.getTriggerObject();
          mainContentObject["trigger"] = triggerObject;
        }

        if(mainContent.type == "CtaSimple"){
          mainContentObject["linkUrl"] = mainContent.linkUrl;
        }
        if(mainContent.type == "MessageSimple"){
          mainContentObject["description"] = mainContent.description;
        }
        if(mainContent.type == "QuestionSelect"){
          mainContentObject["options"] = [];
          for(let option of mainContent.options){
            let optionObject = {
              key: option.key,
              value: option.value,
            };
            if(option.trigger){
              let triggerObject = option.trigger.getTriggerObject();
              optionObject["trigger"] = triggerObject;
            }
            mainContentObject["options"].push(optionObject);
          }
          mainContentObject["required"] = mainContent.required;
        }
        if(mainContent.type == "QuestionText"){
          mainContentObject["required"] = mainContent.required;
        }
        if(mainContent.type == "QuestionRating"){
          mainContentObject["required"] = mainContent.required;
        }    
      }


      mainContentObjects[mainContent.hash] = mainContentObject;
    }
    let playlistObject = {
      startAt: startAt,
      contents: mainContentObjects,
    };
    return playlistObject;
  }

  getPlaylistPlayerUrl(){
    return environment.playerEndPoint + "/pl/?hashPublic=" + this.playlistHashPublic;
  }
  getPlayerHtmlTag(){
    return '<iframe width="100%" height="100%" border="0" src="' + environment.playerEndPoint + '/pl/?hashPublic=' + this.playlistHashPublic + '"></iframe>';
  }

  // 旧 getVideo
  getMainContent(hash):any{
    for(let index in this.contents){
      if(this.contents[index].hash == hash){
        return this.contents[index];
      }
    }
  }
  getSubContentList(videoHash, contentListHash):ContentList{

    if(videoHash){
      let video:Video = this.getMainContent(videoHash);
      if(! video){
        return;
      }
      return video.getContentList(contentListHash);  
    }
    else{
      for(let video of this.contents){
        let contentList = video.getContentList(contentListHash);
        if(contentList){
          return contentList;
        }
      }
    }
  }
  getSubContent(videoHash, contentListHash, contentHash):Content{

    if(! contentListHash){
      return;
    }

    if(videoHash){
      let contentList:ContentList = this.getSubContentList(videoHash, contentListHash);
      if(! contentList){
        return;
      }
      return contentList.getContent(contentHash);
    }
    else{
      for(let video of this.contents){
        let content = video.getContent(contentListHash, contentHash);
        if(content){
          return content;
        }
      }  
    }
  }
}

export interface ReportSummary{
  views?:number;
  viewUsers?:number;
  answers?:number;
}
  